var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "event-info",
        { threeselections: _vm.threeselections },
        { "big-three": _vm.isbig3coupon }
      ],
      attrs: {
        idfoevent: _vm.event.idfoevent.toString(),
        idfosbevent: _vm.event.idfosbevent && _vm.event.idfosbevent.toString(),
        idextevent: _vm.event.idextevent && _vm.event.idextevent.toString()
      }
    },
    [
      _vm.isDebug
        ? [
            _vm._v("\n    EVENT "),
            _c("br"),
            _vm._v("\n    idfoevent " + _vm._s(_vm.event.idfoevent)),
            _c("br"),
            _vm._v("\n    idfosbevent " + _vm._s(_vm.event.idfosbevent)),
            _c("br"),
            _vm._v(
              "\n    foeventinternalorder " +
                _vm._s(_vm.event.foeventinternalorder) +
                " "
            ),
            _c("br"),
            _vm._v("\n    hometeamname " + _vm._s(_vm.event.hometeamname)),
            _c("br"),
            _vm._v(
              "\n    awayteamname " + _vm._s(_vm.event.awayteamname) + "\n  "
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.page !== "coupon"
        ? [
            _vm.awayPlayer &&
            _vm.awayPlayer.name &&
            _vm.homePlayer &&
            _vm.homePlayer.name
              ? [
                  _c("section", { staticClass: "live_header" }, [
                    _c("div", { staticClass: "time-period" }, [
                      _vm._v(_vm._s(_vm.activePeriodName))
                    ]),
                    _vm._v(" "),
                    ["FOOTBALL", "SOCCER", "BASKETBALL", "HANDBALL"].indexOf(
                      _vm.event.idfosporttype
                    ) > -1
                      ? _c(
                          "section",
                          { staticClass: "time-display" },
                          [
                            _vm.matchTimer
                              ? _c("match-time-display", {
                                  attrs: { timer: _vm.matchTimer }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.matchTimer &&
                            _vm.event.istimeractive &&
                            _vm.event.matchcurrenttimeinmins
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatMinutesWithSeconds")(
                                        _vm.event.matchcurrenttimeinmins
                                      )
                                    )
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "icon-live" })
                  ]),
                  _vm._v(" "),
                  _c(
                    "section",
                    {
                      staticClass: "parent",
                      class: { resultsWithSets: _vm.awayPlayerSetScore }
                    },
                    [
                      _vm.event.idfosporttype !== "DARTS"
                        ? _c(
                            "section",
                            { staticClass: "child child-left" },
                            [
                              _vm.isNonBig3FoSportType
                                ? [
                                    _c("div", { staticClass: "team-title" }, [
                                      _c(
                                        "span",
                                        [
                                          _vm.phraseToHighlight
                                            ? _c(
                                                "text-highlight",
                                                {
                                                  attrs: {
                                                    queries:
                                                      _vm.phraseToHighlight
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      " " + _vm.homePlayer.name
                                                    )
                                                  )
                                                ]
                                              )
                                            : [
                                                _vm._v(
                                                  _vm._s(_vm.homePlayer.name)
                                                )
                                              ],
                                          _vm._v(" "),
                                          _vm.event.idfosporttype &&
                                          (_vm.homePlayer.idfosblead ===
                                            _vm.event.idfosbleadactive ||
                                            _vm.homePlayer.flag1)
                                            ? _c("icon", {
                                                attrs: {
                                                  name:
                                                    "icon-" +
                                                    _vm.event.idfosporttype
                                                      .split(" ")
                                                      .join("")
                                                      .toLowerCase(),
                                                  colorName: "white"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.isPitcherVisible
                                        ? _c(
                                            "div",
                                            { staticClass: "pitcher-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("lowercase")(
                                                    _vm.event.homepitchername
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "team-title" }, [
                                      _c(
                                        "span",
                                        { staticClass: "name" },
                                        [
                                          _vm.phraseToHighlight
                                            ? _c(
                                                "text-highlight",
                                                {
                                                  attrs: {
                                                    queries:
                                                      _vm.phraseToHighlight
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      " " + _vm.awayPlayer.name
                                                    )
                                                  )
                                                ]
                                              )
                                            : [
                                                _vm._v(
                                                  _vm._s(_vm.awayPlayer.name)
                                                )
                                              ],
                                          _vm._v(" "),
                                          _vm.event.idfosporttype &&
                                          (_vm.awayPlayer.idfosblead ===
                                            _vm.event.idfosbleadactive ||
                                            _vm.awayPlayer.flag1)
                                            ? _c("icon", {
                                                attrs: {
                                                  name:
                                                    "icon-" +
                                                    _vm.event.idfosporttype
                                                      .split(" ")
                                                      .join("")
                                                      .toLowerCase(),
                                                  colorName: "white"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.isPitcherVisible
                                        ? _c(
                                            "div",
                                            { staticClass: "pitcher-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("lowercase")(
                                                    _vm.event.awaypitchername
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ]
                                : [
                                    _c("div", { staticClass: "team-title" }, [
                                      _c(
                                        "span",
                                        { staticClass: "name" },
                                        [
                                          _vm.phraseToHighlight
                                            ? _c(
                                                "text-highlight",
                                                {
                                                  attrs: {
                                                    queries:
                                                      _vm.phraseToHighlight
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      " " + _vm.awayPlayer.name
                                                    )
                                                  )
                                                ]
                                              )
                                            : [
                                                _vm._v(
                                                  _vm._s(_vm.awayPlayer.name)
                                                )
                                              ],
                                          _vm._v(" "),
                                          _vm.event.idfosporttype &&
                                          (_vm.awayPlayer.idfosblead ===
                                            _vm.event.idfosbleadactive ||
                                            _vm.awayPlayer.flag1)
                                            ? _c("icon", {
                                                attrs: {
                                                  name:
                                                    "icon-" +
                                                    _vm.event.idfosporttype
                                                      .split(" ")
                                                      .join("")
                                                      .toLowerCase(),
                                                  colorName: "white"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.isPitcherVisible
                                        ? _c(
                                            "div",
                                            { staticClass: "pitcher-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("lowercase")(
                                                    _vm.event.awaypitchername
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "team-title" }, [
                                      _c(
                                        "span",
                                        [
                                          _vm.phraseToHighlight
                                            ? _c(
                                                "text-highlight",
                                                {
                                                  attrs: {
                                                    queries:
                                                      _vm.phraseToHighlight
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      " " + _vm.homePlayer.name
                                                    )
                                                  )
                                                ]
                                              )
                                            : [
                                                _vm._v(
                                                  _vm._s(_vm.homePlayer.name)
                                                )
                                              ],
                                          _vm._v(" "),
                                          _vm.event.idfosporttype &&
                                          (_vm.homePlayer.idfosblead ===
                                            _vm.event.idfosbleadactive ||
                                            _vm.homePlayer.flag1)
                                            ? _c("icon", {
                                                attrs: {
                                                  name:
                                                    "icon-" +
                                                    _vm.event.idfosporttype
                                                      .split(" ")
                                                      .join("")
                                                      .toLowerCase(),
                                                  colorName: "white"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.isPitcherVisible
                                        ? _c(
                                            "div",
                                            { staticClass: "pitcher-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("lowercase")(
                                                    _vm.event.homepitchername
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ]
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.event.idfosporttype === "DARTS"
                        ? _c("section", { staticClass: "child child-left" }, [
                            _c("div", { staticClass: "team-title" }, [
                              _c("span", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.homePlayer.idfosblead ===
                                        _vm.event.idfosbleadactive ||
                                      _vm.homePlayer.flag1,
                                    expression:
                                      "homePlayer.idfosblead === event.idfosbleadactive || homePlayer.flag1"
                                  }
                                ],
                                staticClass: "activelead dot-mobile"
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                [
                                  _vm.phraseToHighlight
                                    ? _c(
                                        "text-highlight",
                                        {
                                          attrs: {
                                            queries: _vm.phraseToHighlight
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(" " + _vm.homePlayer.name)
                                          )
                                        ]
                                      )
                                    : [_vm._v(_vm._s(_vm.homePlayer.name))]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("span", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.homePlayer.idfosblead ===
                                        _vm.event.idfosbleadactive ||
                                      _vm.homePlayer.flag1,
                                    expression:
                                      "homePlayer.idfosblead === event.idfosbleadactive || homePlayer.flag1"
                                  }
                                ],
                                staticClass: "activelead dot"
                              }),
                              _vm._v(" "),
                              _vm.isPitcherVisible
                                ? _c("div", { staticClass: "pitcher-name" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("lowercase")(
                                          _vm.event.homepitchername
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "team-title" }, [
                              _c("span", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.awayPlayer.idfosblead ===
                                        _vm.event.idfosbleadactive ||
                                      _vm.awayPlayer.flag1,
                                    expression:
                                      "awayPlayer.idfosblead === event.idfosbleadactive || awayPlayer.flag1"
                                  }
                                ],
                                staticClass: "activelead dot-mobile"
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "name" },
                                [
                                  _vm.phraseToHighlight
                                    ? _c(
                                        "text-highlight",
                                        {
                                          attrs: {
                                            queries: _vm.phraseToHighlight
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(" " + _vm.awayPlayer.name)
                                          )
                                        ]
                                      )
                                    : [_vm._v(_vm._s(_vm.awayPlayer.name))]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("span", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.awayPlayer.idfosblead ===
                                        _vm.event.idfosbleadactive ||
                                      _vm.awayPlayer.flag1,
                                    expression:
                                      "awayPlayer.idfosblead === event.idfosbleadactive || awayPlayer.flag1"
                                  }
                                ],
                                staticClass: "activelead dot"
                              }),
                              _vm._v(" "),
                              _vm.isPitcherVisible
                                ? _c("div", { staticClass: "pitcher-name" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("lowercase")(
                                          _vm.event.awaypitchername
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "section",
                        { staticClass: "child child-right" },
                        [
                          _vm.event.idfosporttype !== "DARTS"
                            ? [
                                _vm.awayPlayerMainScore &&
                                !_vm.awayPlayerSetScore &&
                                !_vm.hideScores
                                  ? _c(
                                      "section",
                                      {
                                        staticClass:
                                          "child result-title main-score"
                                      },
                                      [
                                        _vm.isNonBig3FoSportType
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "current-main-score"
                                                },
                                                [
                                                  _c("table", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "current-score"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm
                                                              .homePlayerMainScore
                                                              .value
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.event.idfosporttype ===
                                                    "CRICKET"
                                                      ? _c("td", [
                                                          _vm._v(" - ")
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.event.idfosporttype ===
                                                    "CRICKET"
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "current-score-wicket"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.homePlayerWicketsScore
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "current-main-score"
                                                },
                                                [
                                                  _c("table", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "current-score"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm
                                                              .awayPlayerMainScore
                                                              .value
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.event.idfosporttype ===
                                                    "CRICKET"
                                                      ? _c("td", [
                                                          _vm._v(" - ")
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.event.idfosporttype ===
                                                    "CRICKET"
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "current-score-wicket"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.awayPlayerWicketsScore
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ])
                                                ]
                                              )
                                            ]
                                          : [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "current-main-score"
                                                },
                                                [
                                                  _c("table", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "current-score"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm
                                                              .awayPlayerMainScore
                                                              .value
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.event.idfosporttype ===
                                                    "CRICKET"
                                                      ? _c("td", [
                                                          _vm._v(" - ")
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.event.idfosporttype ===
                                                    "CRICKET"
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "current-score-wicket"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.awayPlayerWicketsScore
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "current-main-score"
                                                },
                                                [
                                                  _c("table", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "current-score"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm
                                                              .homePlayerMainScore
                                                              .value
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.event.idfosporttype ===
                                                    "CRICKET"
                                                      ? _c("td", [
                                                          _vm._v(" - ")
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.event.idfosporttype ===
                                                    "CRICKET"
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "current-score-wicket"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.homePlayerWicketsScore
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ])
                                                ]
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.awayPlayerSetScore && !_vm.hideScores
                                  ? _c(
                                      "section",
                                      { staticClass: "child result-title" },
                                      [
                                        _vm.isNonBig3FoSportType
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "team-title" },
                                                [
                                                  _c("table", [
                                                    _vm.brandLayout ===
                                                    "generic"
                                                      ? _c("thead", [
                                                          _c(
                                                            "th",
                                                            {
                                                              staticClass:
                                                                "score-title"
                                                            },
                                                            [_vm._v("Sets")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "th",
                                                            {
                                                              staticClass:
                                                                "score-title"
                                                            },
                                                            [_vm._v("Games")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "th",
                                                            {
                                                              staticClass:
                                                                "score-title"
                                                            },
                                                            [_vm._v("Points")]
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "current-score"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .homePlayerMainScore
                                                                .value
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "current-set-score"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.homePlayerCurrentSetScore
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "game-score"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              (!_vm.isTieBreakActive &&
                                                                _vm.homePlayerGameScore &&
                                                                _vm
                                                                  .homePlayerGameScore
                                                                  .value &&
                                                                _vm
                                                                  .gameScoreMap[
                                                                  _vm
                                                                    .homePlayerGameScore
                                                                    .value
                                                                ]) ||
                                                                (_vm.homePlayerGameScore &&
                                                                  _vm
                                                                    .homePlayerGameScore
                                                                    .value)
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "team-title" },
                                                [
                                                  _c("table", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "current-score"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm
                                                              .awayPlayerMainScore
                                                              .value
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "current-set-score"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.awayPlayerCurrentSetScore
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "game-score"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            (!_vm.isTieBreakActive &&
                                                              _vm.awayPlayerGameScore &&
                                                              _vm
                                                                .awayPlayerGameScore
                                                                .value &&
                                                              _vm.gameScoreMap[
                                                                _vm
                                                                  .awayPlayerGameScore
                                                                  .value
                                                              ]) ||
                                                              (_vm.awayPlayerGameScore &&
                                                                _vm
                                                                  .awayPlayerGameScore
                                                                  .value)
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          : [
                                              _c(
                                                "div",
                                                { staticClass: "team-title" },
                                                [
                                                  _c("table", [
                                                    _vm.brandLayout ===
                                                    "generic"
                                                      ? _c("thead", [
                                                          _c(
                                                            "th",
                                                            {
                                                              staticClass:
                                                                "score-title"
                                                            },
                                                            [_vm._v("Sets")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "th",
                                                            {
                                                              staticClass:
                                                                "score-title"
                                                            },
                                                            [_vm._v("Games")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "th",
                                                            {
                                                              staticClass:
                                                                "score-title"
                                                            },
                                                            [_vm._v("Points")]
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "current-score"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .awayPlayerMainScore
                                                                .value
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "current-set-score"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.awayPlayerCurrentSetScore
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "game-score"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              (!_vm.isTieBreakActive &&
                                                                _vm.awayPlayerGameScore &&
                                                                _vm
                                                                  .awayPlayerGameScore
                                                                  .value &&
                                                                _vm
                                                                  .gameScoreMap[
                                                                  _vm
                                                                    .awayPlayerGameScore
                                                                    .value
                                                                ]) ||
                                                                (_vm.awayPlayerGameScore &&
                                                                  _vm
                                                                    .awayPlayerGameScore
                                                                    .value)
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "team-title" },
                                                [
                                                  _c("table", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "current-score"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm
                                                              .homePlayerMainScore
                                                              .value
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "current-set-score"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.homePlayerCurrentSetScore
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "game-score"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            (!_vm.isTieBreakActive &&
                                                              _vm.homePlayerGameScore &&
                                                              _vm
                                                                .homePlayerGameScore
                                                                .value &&
                                                              _vm.gameScoreMap[
                                                                _vm
                                                                  .homePlayerGameScore
                                                                  .value
                                                              ]) ||
                                                              (_vm.homePlayerGameScore &&
                                                                _vm
                                                                  .homePlayerGameScore
                                                                  .value)
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.event.idfosporttype === "DARTS" && !_vm.hideScores
                            ? _c(
                                "section",
                                { staticClass: "child result-title" },
                                [
                                  _c("div", { staticClass: "team-title" }, [
                                    _vm.scoringFormat
                                      ? _c("table", [
                                          _vm.scoringFormat === "SETS"
                                            ? _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "current-score current-score-sets",
                                                  staticStyle: {
                                                    background: "red"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.homePlayerDartsSetsScore
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "current-score current-score-legs"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.homePlayerDartsLegsScore
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "team-title" }, [
                                    _vm.scoringFormat
                                      ? _c("table", [
                                          _vm.scoringFormat === "SETS"
                                            ? _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "current-score current-score-sets"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.awayPlayerDartsSetsScore
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "current-score current-score-legs"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.awayPlayerDartsLegsScore
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                ]
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.page === "coupon"
        ? _c(
            "section",
            [
              _c("v-flex", { staticClass: "names participants" }, [
                _c(
                  "div",
                  {
                    staticClass: "event-info live-coupon-event clickable",
                    class: { "team-logos": _vm.teamLogoVisibility },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.goToEvent(_vm.event)
                      }
                    }
                  },
                  [
                    _vm.isbig3coupon
                      ? _c("div", [
                          _c("section", { staticClass: "eventTitleWrapper" }, [
                            _vm.awayPlayer
                              ? _c(
                                  "div",
                                  { staticClass: "eventTitle away live-e" },
                                  [
                                    _c("span", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.awayPlayer.idfosblead ===
                                              _vm.event.idfosbleadactive ||
                                            _vm.awayPlayer.flag1,
                                          expression:
                                            "awayPlayer.idfosblead === event.idfosbleadactive || awayPlayer.flag1"
                                        }
                                      ],
                                      staticClass: "activelead dot-mobile"
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.awayPlayer.idfosblead ===
                                              _vm.event.idfosbleadactive ||
                                            _vm.awayPlayer.flag1,
                                          expression:
                                            "awayPlayer.idfosblead === event.idfosbleadactive || awayPlayer.flag1"
                                        }
                                      ],
                                      staticClass: "activelead dot"
                                    }),
                                    _vm._v(" "),
                                    _vm.teamLogoVisibility
                                      ? _c("span", {
                                          staticClass: "team-logo",
                                          style: _vm.awayTeamLogoStyle
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.teamLogoVisibility &&
                                    _vm.mobileBigAndBelow
                                      ? _c("span", { staticClass: "name" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.event.shortnameaway ||
                                                _vm.event.participshortaway ||
                                                _vm.awayPlayer.name
                                            )
                                          )
                                        ])
                                      : _c(
                                          "span",
                                          { staticClass: "name" },
                                          [
                                            _vm.phraseToHighlight
                                              ? _c(
                                                  "text-highlight",
                                                  {
                                                    attrs: {
                                                      queries:
                                                        _vm.phraseToHighlight
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        " " +
                                                          _vm.awayPlayer.name
                                                      )
                                                    )
                                                  ]
                                                )
                                              : [
                                                  _vm._v(
                                                    _vm._s(_vm.awayPlayer.name)
                                                  )
                                                ]
                                          ],
                                          2
                                        ),
                                    _vm._v(" "),
                                    _vm.event.awaypitchername &&
                                    _vm.isPitcherVisible
                                      ? _c(
                                          "span",
                                          { staticClass: "pitcher-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("lowercase")(
                                                  _vm.event.awaypitchername
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.awayPlayerMainScore &&
                            _vm.awayPlayerCurrentSetScore !== undefined &&
                            !_vm.hideScores
                              ? _c("div", { staticClass: "showResult" }, [
                                  _c("table", [
                                    _vm.awayPlayer
                                      ? _c(
                                          "tr",
                                          { staticClass: "away-team" },
                                          [
                                            _vm.awayPlayerMainScore
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "score-value"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.awayPlayerMainScore
                                                          .value
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.event.idfosporttype ===
                                            "CRICKET"
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "current-score game-score"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.awayPlayerWicketsScore
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            this.periodScoreCounterNameBySport[
                                              _vm.event.idfosporttype
                                            ]
                                              ? [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "current-set-score"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.awayPlayerCurrentSetScore
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "game-score"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          (!_vm.isTieBreakActive &&
                                                            _vm.awayPlayerGameScore &&
                                                            _vm
                                                              .awayPlayerGameScore
                                                              .value &&
                                                            _vm.gameScoreMap[
                                                              _vm
                                                                .awayPlayerGameScore
                                                                .value
                                                            ]) ||
                                                            (_vm.awayPlayerGameScore &&
                                                              _vm
                                                                .awayPlayerGameScore
                                                                .value)
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("section", { staticClass: "eventTitleWrapper" }, [
                            _vm.homePlayer
                              ? _c(
                                  "div",
                                  { staticClass: "eventTitle home live-e" },
                                  [
                                    _c("span", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.homePlayer.idfosblead ===
                                              _vm.event.idfosbleadactive ||
                                            _vm.homePlayer.flag1,
                                          expression:
                                            "homePlayer.idfosblead === event.idfosbleadactive || homePlayer.flag1"
                                        }
                                      ],
                                      staticClass: "activelead dot-mobile"
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.homePlayer.idfosblead ===
                                              _vm.event.idfosbleadactive ||
                                            _vm.homePlayer.flag1,
                                          expression:
                                            "homePlayer.idfosblead === event.idfosbleadactive || homePlayer.flag1"
                                        }
                                      ],
                                      staticClass: "activelead dot"
                                    }),
                                    _vm._v(" "),
                                    _vm.teamLogoVisibility
                                      ? _c("span", {
                                          staticClass: "team-logo",
                                          style: _vm.homeTeamLogoStyle
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.teamLogoVisibility &&
                                    _vm.mobileBigAndBelow
                                      ? _c("span", { staticClass: "name" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.event.shortnamehome ||
                                                _vm.event.participshorthome ||
                                                _vm.homePlayer.name
                                            )
                                          )
                                        ])
                                      : _c(
                                          "span",
                                          { staticClass: "name" },
                                          [
                                            _vm.phraseToHighlight
                                              ? _c(
                                                  "text-highlight",
                                                  {
                                                    attrs: {
                                                      queries:
                                                        _vm.phraseToHighlight
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        " " +
                                                          _vm.homePlayer.name
                                                      )
                                                    )
                                                  ]
                                                )
                                              : [
                                                  _vm._v(
                                                    _vm._s(_vm.homePlayer.name)
                                                  )
                                                ]
                                          ],
                                          2
                                        ),
                                    _vm._v(" "),
                                    _vm.event.homepitchername &&
                                    _vm.isPitcherVisible
                                      ? _c(
                                          "span",
                                          { staticClass: "pitcher-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("lowercase")(
                                                  _vm.event.homepitchername
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.homePlayerMainScore &&
                            _vm.homePlayerCurrentSetScore !== undefined &&
                            !_vm.hideScores
                              ? _c("div", { staticClass: "showResult" }, [
                                  _c("table", [
                                    _vm.homePlayer
                                      ? _c(
                                          "tr",
                                          { staticClass: "home-team" },
                                          [
                                            _vm.homePlayerMainScore
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "score-value"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.homePlayerMainScore
                                                          .value
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.event.idfosporttype ===
                                            "CRICKET"
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "current-score game-score"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.homePlayerWicketsScore
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            this.periodScoreCounterNameBySport[
                                              _vm.event.idfosporttype
                                            ]
                                              ? [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "current-set-score"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.homePlayerCurrentSetScore
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "game-score"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          (!_vm.isTieBreakActive &&
                                                            _vm.homePlayerGameScore &&
                                                            _vm
                                                              .homePlayerGameScore
                                                              .value &&
                                                            _vm.gameScoreMap[
                                                              _vm
                                                                .homePlayerGameScore
                                                                .value
                                                            ]) ||
                                                            (_vm.homePlayerGameScore &&
                                                              _vm
                                                                .homePlayerGameScore
                                                                .value)
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              : _vm._e()
                          ])
                        ])
                      : _c("div", [
                          _c("section", { staticClass: "eventTitleWrapper" }, [
                            _vm.homePlayer
                              ? _c(
                                  "div",
                                  { staticClass: "eventTitle home live-e" },
                                  [
                                    _c("span", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.homePlayer.idfosblead ===
                                              _vm.event.idfosbleadactive ||
                                            _vm.homePlayer.flag1,
                                          expression:
                                            "homePlayer.idfosblead === event.idfosbleadactive || homePlayer.flag1"
                                        }
                                      ],
                                      staticClass: "activelead dot-mobile"
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.homePlayer.idfosblead ===
                                              _vm.event.idfosbleadactive ||
                                            _vm.homePlayer.flag1,
                                          expression:
                                            "homePlayer.idfosblead === event.idfosbleadactive || homePlayer.flag1"
                                        }
                                      ],
                                      staticClass: "activelead dot"
                                    }),
                                    _vm._v(" "),
                                    _vm.teamLogoVisibility
                                      ? _c("span", {
                                          staticClass: "team-logo",
                                          style: _vm.homeTeamLogoStyle
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.teamLogoVisibility &&
                                    _vm.mobileBigAndBelow
                                      ? _c("span", { staticClass: "name" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.event.shortnamehome ||
                                                _vm.event.participshorthome ||
                                                _vm.homePlayer.name
                                            )
                                          )
                                        ])
                                      : _c(
                                          "span",
                                          { staticClass: "name" },
                                          [
                                            _vm.phraseToHighlight
                                              ? _c(
                                                  "text-highlight",
                                                  {
                                                    attrs: {
                                                      queries:
                                                        _vm.phraseToHighlight
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        " " +
                                                          _vm.homePlayer.name
                                                      )
                                                    )
                                                  ]
                                                )
                                              : [
                                                  _vm._v(
                                                    _vm._s(_vm.homePlayer.name)
                                                  )
                                                ],
                                            _vm._v(" "),
                                            _vm.event.idfosporttype &&
                                            (_vm.homePlayer.idfosblead ===
                                              _vm.event.idfosbleadactive ||
                                              _vm.homePlayer.flag1)
                                              ? _c("icon", {
                                                  attrs: {
                                                    name:
                                                      "icon-" +
                                                      _vm.event.idfosporttype
                                                        .split(" ")
                                                        .join("")
                                                        .toLowerCase(),
                                                    colorName: "blue"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          2
                                        ),
                                    _vm._v(" "),
                                    _vm.event.homepitchername &&
                                    _vm.isPitcherVisible
                                      ? _c(
                                          "span",
                                          { staticClass: "pitcher-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("lowercase")(
                                                  _vm.event.homepitchername
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.homePlayerMainScore &&
                            _vm.homePlayerCurrentSetScore !== undefined &&
                            !_vm.hideScores
                              ? _c("div", { staticClass: "showResult" }, [
                                  _c("table", [
                                    _vm.event.idfosporttype !== "DARTS" &&
                                    _vm.homePlayer
                                      ? _c(
                                          "tr",
                                          { staticClass: "home-team" },
                                          [
                                            _vm.homePlayerMainScore
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "score-value"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.homePlayerMainScore
                                                          .value
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.event.idfosporttype ===
                                            "CRICKET"
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "current-score game-score"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.homePlayerWicketsScore
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            this.periodScoreCounterNameBySport[
                                              _vm.event.idfosporttype
                                            ]
                                              ? [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "current-set-score"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.homePlayerCurrentSetScore
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "game-score"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          (!_vm.isTieBreakActive &&
                                                            _vm.homePlayerGameScore &&
                                                            _vm
                                                              .homePlayerGameScore
                                                              .value &&
                                                            _vm.gameScoreMap[
                                                              _vm
                                                                .homePlayerGameScore
                                                                .value
                                                            ]) ||
                                                            (_vm.homePlayerGameScore &&
                                                              _vm
                                                                .homePlayerGameScore
                                                                .value)
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.scoringFormat &&
                                    _vm.event.idfosporttype === "DARTS" &&
                                    _vm.homePlayer
                                      ? _c("tr", { staticClass: "home-team" }, [
                                          _vm.scoringFormat === "SETS"
                                            ? _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "current-score current-score-sets"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.homePlayerDartsSetsScore
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "current-score current-score-legs"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.homePlayerDartsLegsScore
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("section", { staticClass: "eventTitleWrapper" }, [
                            _vm.awayPlayer
                              ? _c(
                                  "div",
                                  { staticClass: "eventTitle away live-e" },
                                  [
                                    _c("span", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.awayPlayer.idfosblead ===
                                              _vm.event.idfosbleadactive ||
                                            _vm.awayPlayer.flag1,
                                          expression:
                                            "awayPlayer.idfosblead === event.idfosbleadactive || awayPlayer.flag1"
                                        }
                                      ],
                                      staticClass: "activelead dot-mobile"
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.awayPlayer.idfosblead ===
                                              _vm.event.idfosbleadactive ||
                                            _vm.awayPlayer.flag1,
                                          expression:
                                            "awayPlayer.idfosblead === event.idfosbleadactive || awayPlayer.flag1"
                                        }
                                      ],
                                      staticClass: "activelead dot"
                                    }),
                                    _vm._v(" "),
                                    _vm.teamLogoVisibility
                                      ? _c("span", {
                                          staticClass: "team-logo",
                                          style: _vm.awayTeamLogoStyle
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.teamLogoVisibility &&
                                    _vm.mobileBigAndBelow
                                      ? _c("span", { staticClass: "name" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.event.shortnameaway ||
                                                _vm.event.participshortaway ||
                                                _vm.awayPlayer.name
                                            )
                                          )
                                        ])
                                      : _c(
                                          "span",
                                          { staticClass: "name" },
                                          [
                                            _vm.phraseToHighlight
                                              ? _c(
                                                  "text-highlight",
                                                  {
                                                    attrs: {
                                                      queries:
                                                        _vm.phraseToHighlight
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        " " +
                                                          _vm.awayPlayer.name
                                                      )
                                                    )
                                                  ]
                                                )
                                              : [
                                                  _vm._v(
                                                    _vm._s(_vm.awayPlayer.name)
                                                  )
                                                ],
                                            _vm._v(" "),
                                            _vm.event.idfosporttype &&
                                            (_vm.awayPlayer.idfosblead ===
                                              _vm.event.idfosbleadactive ||
                                              _vm.awayPlayer.flag1)
                                              ? _c("icon", {
                                                  class:
                                                    "icon-" +
                                                    _vm.event.idfosporttype
                                                      .split(" ")
                                                      .join("")
                                                      .toLowerCase(),
                                                  attrs: { colorName: "blue" }
                                                })
                                              : _vm._e()
                                          ],
                                          2
                                        ),
                                    _vm._v(" "),
                                    _vm.event.awaypitchername &&
                                    _vm.isPitcherVisible
                                      ? _c(
                                          "span",
                                          { staticClass: "pitcher-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("lowercase")(
                                                  _vm.event.awaypitchername
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.awayPlayerMainScore &&
                            _vm.awayPlayerCurrentSetScore !== undefined &&
                            !_vm.hideScores
                              ? _c("div", { staticClass: "showResult" }, [
                                  _c("table", [
                                    _vm.event.idfosporttype !== "DARTS" &&
                                    _vm.awayPlayer
                                      ? _c(
                                          "tr",
                                          { staticClass: "away-team" },
                                          [
                                            _vm.awayPlayerMainScore
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "score-value"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.awayPlayerMainScore
                                                          .value
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.event.idfosporttype ===
                                            "CRICKET"
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "current-score game-score"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.awayPlayerWicketsScore
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            this.periodScoreCounterNameBySport[
                                              _vm.event.idfosporttype
                                            ]
                                              ? [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "current-set-score"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.awayPlayerCurrentSetScore
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "game-score"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          (!_vm.isTieBreakActive &&
                                                            _vm.awayPlayerGameScore &&
                                                            _vm
                                                              .awayPlayerGameScore
                                                              .value &&
                                                            _vm.gameScoreMap[
                                                              _vm
                                                                .awayPlayerGameScore
                                                                .value
                                                            ]) ||
                                                            (_vm.awayPlayerGameScore &&
                                                              _vm
                                                                .awayPlayerGameScore
                                                                .value)
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.scoringFormat &&
                                    _vm.event.idfosporttype === "DARTS" &&
                                    _vm.awayPlayer
                                      ? _c("tr", { staticClass: "away-team" }, [
                                          _vm.scoringFormat === "SETS"
                                            ? _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "current-score current-score-sets"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.awayPlayerDartsSetsScore
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "current-score current-score-legs"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.awayPlayerDartsLegsScore
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ])
                              : _vm._e()
                          ])
                        ])
                  ]
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b3afd8b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b3afd8b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/live/liveEventInfo.vue
// module id = null
// module chunks = 